import React from 'react';
import { Card, Typography, Space, Tag, Divider } from 'antd';
import { SecurityScanOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const SecuritySettings: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <SecurityScanOutlined style={{ marginRight: 8 }} />
              Security Settings
            </Title>
            <Tag color="orange">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>Account Security</Title>
            <Paragraph>
              This page will contain security-related settings and configurations.
              Features will include:
            </Paragraph>
            <ul>
              <li>Password management and policies</li>
              <li>Two-factor authentication setup</li>
              <li>Session management and timeout settings</li>
              <li>Login history and activity monitoring</li>
              <li>IP whitelist and access controls</li>
            </ul>
          </div>
          
          <div style={{ 
            background: '#fff7e6', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #ffd591'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#fa8c16' }} />
              <Text type="secondary">
                Security features are being developed to ensure your data protection.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default SecuritySettings;
